import { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Images from "../../constant/images";
import "../signup/signup.css";
import { localStorageKey, screenPath } from "../../constant/strings";
import { FaArrowLeft } from "react-icons/fa";
import { createBusinessApi, signupApi } from "../../services/apiCall";
import { jwtDecode } from "jwt-decode";

const Signup = () => {
  const [name, setName] = useState("");
  const [bname, setBname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [cshowPassword, setCshowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userType = queryParams.get("type");
  console.log("userType", userType);

  const validate = () => {
    const newErrors = {};
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();

    if (!name.trim()) newErrors.name = "Name is required";
    // if (!bname.trim()) newErrors.businessName = "Business name is required";
    if (!phoneNumber.trim()) newErrors.phoneNumber = "Phone number is required";
    else if (!/^\d{10}$/.test(phoneNumber))
      newErrors.phoneNumber = "Enter a valid 10-digit phone number";

    if (!trimmedEmail) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(trimmedEmail)) {
      newErrors.email = "Enter a valid email";
    }

    if (!trimmedPassword) {
      newErrors.password = "Password is required";
    } else if (trimmedPassword.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    if (!cpassword.trim()) {
      newErrors.cpassword = "Confirm your password";
    } else if (cpassword !== password) {
      newErrors.cpassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const payload = {
        name,
        // businessName: bname,
        phoneNumber,
        email,
        password,
      };

      console.log("playload", payload);
      // API call example (uncomment and adjust)
      // await axios.post("/api/signup", payload);
      const res = await signupApi(payload);
      console.log("res>>>>>", res?.data);
      if (
        res?.data?.token !== null &&
        res?.data?.token !== undefined &&
        res?.data?.token !== ""
      ) {
        // const token = localStorage.setItem(
        //   localStorageKey.authToken,
        //   res?.data?.token
        // );
        // const decoded = jwtDecode(res?.data?.token);
        setToastMessage("Signup successful!");
        setShowToast(true);
        setTimeout(
          () => navigate(`${screenPath.login}?type=${userType}`),
          2000
        );
        // const payloadCreateBusiness = {
        //   email: email,
        //   name: name,
        //   business_name: bname,
        //   phone: phoneNumber,
        //   userId: decoded.id,
        //   postCode: "cv22 878",
        //   registrationNo: "1234567",
        //   vatNo: "1234567",
        // };
        // console.log("payloadCreateBusiness>>>>>", payloadCreateBusiness);
        // const responseCreateBusiness = await createBusinessApi(
        //   payloadCreateBusiness
        // );
        // console.log(
        //   "responseCreateBusiness>>>>>",
        //   responseCreateBusiness?.data?.business
        // );
        // if (responseCreateBusiness?.data?.business) {
        //   localStorage.removeItem(localStorageKey.authToken);
        //   setToastMessage("Signup successful!");
        //   setShowToast(true);
        //   setTimeout(
        //     () => navigate(`${screenPath.login}?type=${userType}`),
        //     2000
        //   );
        // }
      } else {
        setToastMessage("Signup failed. Please try again.");
        setShowToast(true);
      }
    } catch (error) {
      setToastMessage("Signup failed. Please try again.");
      setShowToast(true);
    }
  };

  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        setShowToast(false);
        setToastMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showToast]);

  return (
    <div className="login-container">
      <div className="login-left">
        <img src={Images.logo} alt="Logo" className="login-logo" />
      </div>

      <div className="login-right">
        <FaArrowLeft
          className="back-arrow"
          onClick={() => navigate(`${screenPath.login}?type=${userType}`)}
        />
        <h2>Sign up</h2>

        <form onSubmit={handleSubmit} className="login-form">
          {/* Name */}
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
            />
            {errors.name && <p className="error-text">{errors.name}</p>}
          </div>

          {/* Business Name */}
          {/* <div className="form-group">
            <label htmlFor="bname">Business Name</label>
            <input
              id="bname"
              type="text"
              value={bname}
              onChange={(e) => setBname(e.target.value)}
              placeholder="Enter your business name"
            />
            {errors.businessName && (
              <p className="error-text">{errors.businessName}</p>
            )}
          </div> */}

          {/* Phone Number */}
          <div className="form-group">
            <label htmlFor="phoneNumber">Phone Number</label>
            <input
              id="phoneNumber"
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter your phone number"
            />
            {errors.phoneNumber && (
              <p className="error-text">{errors.phoneNumber}</p>
            )}
          </div>

          {/* Email */}
          <div className="form-group">
            <label htmlFor="email">Email ID</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
            {errors.email && <p className="error-text">{errors.email}</p>}
          </div>

          {/* Password */}
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-field">
              {" "}
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="password-input"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
            {errors.password && <p className="error-text">{errors.password}</p>}
          </div>

          {/* Confirm Password - Same fix */}
          <div className="form-group">
            <label htmlFor="cpassword">Confirm Password</label>
            <div className="password-field">
              <input
                id="cpassword"
                type={cshowPassword ? "text" : "password"}
                value={cpassword}
                onChange={(e) => setCpassword(e.target.value)}
                placeholder="Confirm your password"
                className="password-input"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setCshowPassword(!cshowPassword)}
                aria-label={cshowPassword ? "Hide password" : "Show password"}
              >
                {cshowPassword ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
            {errors.cpassword && (
              <p className="error-text">{errors.cpassword}</p>
            )}
          </div>

          {/* Submit Button */}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="login-btns"
          >
            Save
          </Button>
        </form>

        {/* Toast Notification */}
        {showToast && (
          <div className="toast success-toast" role="alert">
            {toastMessage}
            <button
              type="button"
              className="toast-close"
              onClick={() => setShowToast(false)}
              aria-label="Close toast"
            >
              ×
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Signup;
